// extracted by mini-css-extract-plugin
export default {"addToCartControl":"B_-z","giftCard":"C_-z","btnContainer":"D_-z","cartButton":"E_-z","disabled":"F_-z","stockMessage":"G_-z"};